import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DynamicLabelModel } from '@core/models/models';
@Component({
  selector: 'caremoni-dynamic-label',
  templateUrl: './dynamic-label.component.html',
  styleUrls: ['./dynamic-label.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicLabelComponent implements OnInit {

  @Input() data: string = '';
  @Input() config: DynamicLabelModel = new DynamicLabelModel();

  ngOnInit(): void {
    if(!this.config) this.config = new DynamicLabelModel();
    if(!this.data) this.data = '';
  }
}
